module.exports = __webpack_public_path__ + "img/logoSar.a6ab09fd.png";